export enum PlanwertType {
    BRUTTONENNLEISTUNG = 'BRUTTONENNLEISTUNG',
    SR_ID = 'SR_ID',
    SG_ID = 'SG_ID',
    ANLAGENBETREIBER_NAME = 'ANLAGENBETREIBER_NAME',
    ANLAGENBETREIBER_STRASSE = 'ANLAGENBETREIBER_STRASSE',
    ANLAGENBETREIBER_HAUSNUMMER = 'ANLAGENBETREIBER_HAUSNUMMER',
    ANLAGENBETREIBER_HAUSNUMMER_ZUSATZ = 'ANLAGENBETREIBER_HAUSNUMMER_ZUSATZ',
    ANLAGENBETREIBER_PLZ = 'ANLAGENBETREIBER_PLZ',
    ANLAGENBETREIBER_ORT = 'ANLAGENBETREIBER_ORT',
    MARKTLOKATION = 'MARKTLOKATION',
    BILANZKREIS = 'BILANZKREIS',
    LIEFERANT_MARKTLOKATION = 'LIEFERANT_MARKTLOKATION',
    TRANCHE_MARKTLOKATION = 'TRANCHE_MARKTLOKATION',
    TRANCHE_BILANZKREIS = 'TRANCHE_BILANZKREIS',
    TRANCHE_LIEFERANT = 'TRANCHE_LIEFERANT',
    TRANCHE_GROESSE = 'TRANCHE_GROESSE',
}

export class PlanwertTypeItem {

    public key: PlanwertType;
    public description: string;

    constructor(key: PlanwertType, description: string) {
        this.key = key;
        this.description = description;
    }

    public static getAll(): PlanwertTypeItem[] {
        return [
            new PlanwertTypeItem(PlanwertType.BRUTTONENNLEISTUNG, 'Bruttonennleistung'),
            new PlanwertTypeItem(PlanwertType.SR_ID, 'SR-ID'),
            new PlanwertTypeItem(PlanwertType.SG_ID, 'SG-ID'),
            new PlanwertTypeItem(PlanwertType.ANLAGENBETREIBER_NAME, 'Anlagenbetreiber Name'),
            new PlanwertTypeItem(PlanwertType.ANLAGENBETREIBER_STRASSE, 'Anlagenbetreiber Str.'),
            new PlanwertTypeItem(PlanwertType.ANLAGENBETREIBER_HAUSNUMMER, 'Anlagenbetreiber Hausnummer'),
            new PlanwertTypeItem(PlanwertType.ANLAGENBETREIBER_HAUSNUMMER_ZUSATZ, 'Anlagenbetreiber Hausnummerzusatz'),
            new PlanwertTypeItem(PlanwertType.ANLAGENBETREIBER_PLZ, 'Anlagenbetreiber PLZ'),
            new PlanwertTypeItem(PlanwertType.ANLAGENBETREIBER_ORT, 'Anlagenbetreiber Ort'),
            new PlanwertTypeItem(PlanwertType.MARKTLOKATION, 'Marktlokation'),
            new PlanwertTypeItem(PlanwertType.BILANZKREIS, 'Identifikator des Bilanzkreis'),
            new PlanwertTypeItem(PlanwertType.LIEFERANT_MARKTLOKATION, 'Lieferant-Marktlokation'),
            new PlanwertTypeItem(PlanwertType.TRANCHE_MARKTLOKATION, 'Marktlokation Tranche'),
            new PlanwertTypeItem(PlanwertType.TRANCHE_BILANZKREIS, 'Bilanzkreis Tranche'),
            new PlanwertTypeItem(PlanwertType.TRANCHE_LIEFERANT, 'Lieferant Tranche'),
            new PlanwertTypeItem(PlanwertType.TRANCHE_GROESSE, 'Tranchengröße [%]'),
        ];
    }

}
